import type {Segment} from '@Shared/Models/Segment';
import {getObjectValues} from '@Shared/Util/getObjectValues';

const getTimeSortedBufferRanges = (bufferRangeMap: Record<string, Segment>) =>
    getObjectValues(bufferRangeMap).sort((a, b) => a.endTimeSeconds - b.endTimeSeconds);

export {getTimeSortedBufferRanges};
